export class SchoolPackageViewTile{
  id: number;
  schoolId: number;
  name: string;
  description: string;
  amountPerStudent: number;
  imageUrl: string;
  enabled: boolean;
  accessdays: number;
}